import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { NoTeamAvailableError } from '../../../../shared/errors/NoTeamAvailableError.js'

import { logger } from '../../../lib/logging'
import app from '../../../app.jsx'
import storage from '../../../lib/localstorage.jsx'
import { AccountLocked } from '../../../library/authentication/accountLocked'
import { InvalidCredentials } from '../../../library/authentication/invalidCredentials'
import LoginContent from '../../login/login_contentv2/login_contentv2.jsx'
import DialogTeamSelect from '../../team/dialog_team_select/dialog_team_select.jsx'

class PageLogin extends Component {
  constructor (props) {
    super(props)

    this._references = {
      loginContent: React.createRef()
    }

    this.state = {
      // Copy over the teams from the app that contains the teams of the currently authenticated user.
      teams: app.isLoggedIn ? app.availableTeams : null,
      activeTeam: app.isLoggedIn ? app.activeTeam : null,
      isLoading: false
    }
  }

  static get propTypes () {
    return {
      showForgot: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      showForgot: false
    }
  }

  setIsLoading (isLoading) {
    this.setState({ isLoading })
  }

  render () {
    const { activeTeam } = this.state

    // If the user already has an active team we redirect back to dashboard.
    if (activeTeam) {
      app.redirect('/')

      return null
    }

    return (
      <div className='page-loginv2'>
        <LoginContent
          ref={this._references.loginContent}
          title='user.login.title'
          onLogin={this.onLogin.bind(this)}
          onForgot={this.onForgot.bind(this)}
          showForgot={this.props.showForgot || false}
          onClickLogin={this.handleClickLogin}
          onClickForgot={this.handleClickForgot}
          isLoading={this.state.isLoading}
          setIsLoading={this.setIsLoading.bind(this)}
        />

        {this.state.teams && (
          <DialogTeamSelect
            teams={this.state.teams}
            onSelect={this.onTeamSelect.bind(this)}
          />
        )}
      </div>
    )
  }

  onLogin (email, password) {
    return app.authentication.login({
      email,
      password
    }).then(({ activeTeam, availableTeams }) => {
      if (activeTeam) {
        return app.redirect('/')
      }

      // Otherwise, we set the teams to the state so the team selector will be shown.
      this.setState({ teams: availableTeams })
    }).catch(error => {
      let message

      if (error instanceof InvalidCredentials) {
        message = 'user.login.msgInvalidValues'
      }

      if (error instanceof NoTeamAvailableError) {
        message = 'user.login.msgInvalidTeams'
      }

      if (error instanceof AccountLocked) {
        message = 'user.login.msgAccountLocked'
      }

      if (this._references.loginContent.current && message) {
        this._references.loginContent.current.showError(message)
      } else {
        logger.error(error)
      }
    })
  }

  onTeamSelect (teamId) {
    return app.authentication.afterLogin(app.user, teamId).then(() => {
      return app.redirect('/')
    })
  }

  handleClickForgot (event) {
    event.preventDefault()
    app.changePage('forgot-password')
  }

  handleClickLogin (event) {
    event.preventDefault()
    app.changePage('login')
  }

  onForgot (email, onSuccess) {
    storage.clear()
    app.service('/api/userreset')
      .create({ email: email.toLowerCase() })
      .then(() => {
        if (this._references.loginContent.current) {
          this._references.loginContent.current.showForgotSuccess()
        }
        app.changePage('login')
      })
      .catch(() => {
        if (this._references.loginContent.current) {
          this._references.loginContent.current.showForgotError()
        }
      })
      .finally(() => {
        this.setIsLoading(false)
      })
  }
}

export default PageLogin
